import React from 'react'
import './DropDownMenu.css'

export const DropDownMenu = ({ items = [] }) => {
    return (
        <div className="user-dropdown">
            {items.map((item) => (
                <button key={item.index} onClick={() => item.onClick(item.index)}>
                    {item.label}
                </button>
            ))}
        </div>
    )
}
